import axios from 'axios';
import classnames from 'classnames';
import Loader from 'react-loader-spinner';
import MDEditor from '@uiw/react-md-editor';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import SidebarWrap from '../SidebarWrap';
import pmt1 from '../../images/checkout/img-1.png';
import pmt2 from '../../images/checkout/img-2.png';
import pmt3 from '../../images/checkout/img-3.png';
import pmt4 from '../../images/checkout/img-4.png';

import './style.css';

const CaseSingle = (props) => {
  const [cause, setCause] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { causeId } = useParams();

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    axios
      .get(`${baseUrl}/cause/${causeId}`)
      .then((res) => {
        setCause(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoadingError(true);
        setLoading(false);
      });
  }, [baseUrl, causeId]);

  return (
    <div className="wpo-case-details-area section-padding">
      <div className="container">
        {loading ? (
          <div className="loader-container">
            <Loader type="Oval" color="#d90404" height={80} width={80} />
          </div>
        ) : loadingError ? (
          <div className="text-center">
            <p>Could not fetch the cause. Refresh or check back later.</p>
          </div>
        ) : (
          <div className="row">
            <div className="col col-lg-8">
              <div className="wpo-case-details-wrap">
                <div className="wpo-case-details-img">
                  <img src={cause.image} alt="" />
                </div>
                <div className="wpo-case-details-tab">
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => {
                          toggle('1');
                        }}
                      >
                        Description
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => {
                          toggle('2');
                        }}
                      >
                        Donations
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
                <div className="wpo-case-details-text">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <div className="row">
                        <div className="col-12">
                          <div className="wpo-case-content">
                            <div className="wpo-case-text-top">
                              <h2>{cause.title}</h2>
                              <div className="progress-section">
                                <div className="process">
                                  <div className="progress">
                                    {/* TODO: IMPLEMENT DYNAMIC PROGRESS LATER */}
                                    {/* <div className='progress-bar'>
                                      <div className='progress-value'>
                                        <span>65.5</span>%
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              <ul>
                                <li>
                                  <span>Raised:</span> $ {cause.raisedAmount}
                                </li>
                                <li>
                                  <span>Goal:</span> $ {cause.targetAmount}
                                </li>
                                <li>
                                  <span>Donors:</span> {cause.donors}
                                </li>
                              </ul>
                              <div className="case-b-text">
                                <MDEditor.Markdown source={cause.body} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <form onSubmit={SubmitHandler} action="#">
                        <div className="wpo-donations-amount">
                          <h2>Your Donation</h2>
                          <input
                            type="text"
                            className="form-control"
                            name="text"
                            id="text"
                            placeholder="Enter Donation Amount"
                          />
                        </div>
                        <div className="wpo-donations-details">
                          <h2>Details</h2>
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                id="fname"
                                placeholder="First Name"
                              />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                id="name"
                                placeholder="Last Name"
                              />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group clearfix">
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                id="email"
                                placeholder="Email"
                              />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                              <input
                                type="text"
                                className="form-control"
                                name="Adress"
                                id="Adress"
                                placeholder="Adress"
                              />
                            </div>
                            <div className="col-lg-12 col-12 form-group">
                              <textarea
                                className="form-control"
                                name="note"
                                id="note"
                                placeholder="Message"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="wpo-doanation-payment">
                          <h2>Choose Your Payment Method</h2>
                          <div className="wpo-payment-area">
                            <div className="row">
                              <div className="col-12">
                                <div className="wpo-payment-option" id="open4">
                                  <div className="wpo-payment-select">
                                    <ul>
                                      <li className="addToggle">
                                        <input
                                          id="add"
                                          type="radio"
                                          name="payment"
                                          value="30"
                                        />
                                        <label htmlFor="add">
                                          Payment By Card
                                        </label>
                                      </li>
                                      <li className="removeToggle">
                                        <input
                                          id="remove"
                                          type="radio"
                                          name="payment"
                                          value="30"
                                        />
                                        <label htmlFor="remove">
                                          Offline Donation
                                        </label>
                                      </li>
                                    </ul>
                                  </div>
                                  <div id="open5" className="payment-name">
                                    <ul>
                                      <li className="visa">
                                        <input
                                          id="1"
                                          type="radio"
                                          name="size"
                                          value="30"
                                        />
                                        <label htmlFor="1">
                                          <img src={pmt1} alt="" />
                                        </label>
                                      </li>
                                      <li className="mas">
                                        <input
                                          id="2"
                                          type="radio"
                                          name="size"
                                          value="30"
                                        />
                                        <label htmlFor="2">
                                          <img src={pmt2} alt="" />
                                        </label>
                                      </li>
                                      <li className="ski">
                                        <input
                                          id="3"
                                          type="radio"
                                          name="size"
                                          value="30"
                                        />
                                        <label htmlFor="3">
                                          <img src={pmt3} alt="" />
                                        </label>
                                      </li>
                                      <li className="pay">
                                        <input
                                          id="4"
                                          type="radio"
                                          name="size"
                                          value="30"
                                        />
                                        <label htmlFor="4">
                                          <img src={pmt4} alt="" />
                                        </label>
                                      </li>
                                    </ul>
                                    <div className="contact-form form-style">
                                      <div className="row">
                                        <div className="col-lg-6 col-md-12 col-12">
                                          <label>Card holder Name</label>
                                          <input
                                            type="text"
                                            placeholder=""
                                            name="name"
                                          />
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                          <label>Card Number</label>
                                          <input
                                            type="text"
                                            placeholder=""
                                            id="card"
                                            name="card"
                                          />
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                          <label>CVV</label>
                                          <input
                                            type="text"
                                            placeholder=""
                                            name="CVV"
                                          />
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                          <label>Expire Date</label>
                                          <input
                                            type="text"
                                            placeholder=""
                                            name="date"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="submit-area">
                          <button
                            type="submit"
                            className="theme-btn submit-btn"
                          >
                            Donate Now
                          </button>
                        </div>
                      </form>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
            <SidebarWrap />
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseSingle;
